import { parseResourceFileToObj } from '&/utils/common';

const modulesFiles = require.context('@/locales/en-US', true, /\.js$/);

let lang = parseResourceFileToObj(modulesFiles);

export default lang;
